// This function allow to reference chunks
__webpack_require__.u = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "" + {"1671": "js-legacy","8626": "head-common","878": "stage_automation_icon","9474": "vendor",}[chunkId] + "-" + {"1671": "6c62a3c763bf6e64","8626": "13b73e69bf613ac3","878": "93b12e841f2af0e8","9474": "4b677815fce631e9",}[chunkId] + ".js"
}